import Image from "next/image";
import { FC } from "react";
import Link from "next/link";

import SubLayout from "@/containers/layout/LandingLayout/SubLayout";
import routes from "@/constants/routes";

const TheOdds: FC = () => {
  return (
    <SubLayout>
      <section className="flex flex-col w-full mx-auto md:mb-9 xl:mb-0 max-w-screen-xxl xl:flex-row md:justify-center md:flex-row mt-11 xl:mt-16 xl:max-w-6xl 3xl:max-w-screen-2xl 3xl:justify-between">
        <div className="md:w-3/5 xl:w-auto xl:mb-12">
          <h2 className="xl:w-[30.5rem] font-bold md:max-w-[26.75rem] xl:max-w-[33.75rem] text-landing-blue text-[2.625rem] xl:text-5xl leading-[49px] xl:leading-[61px]">
            The odds are stacked against us
          </h2>
          <p className="mt-8 text-base xl:w-[34rem] md:max-w-[26.75rem] xl:max-w-[34rem] text-landing-blue">
            It has never been as difficult to buy a home than it is today. Mortgage lender&apos;s
            rules and restrictions for borrowers are out of date. Endless house price increases,
            slow wage growth and the cost of living crisis have excluded millions from their
            homeownership dream.
          </p>

          <p className="mt-6 text-base xl:w-[34rem] md:max-w-[26.75rem] xl:max-w-[34rem] text-landing-blue">
            It&apos;s time for change.
          </p>

          <p className="text-base mt-6 xl:w-[34rem] md:max-w-[26.75rem] xl:max-w-[34rem] text-landing-blue">
            At Keyzy, we made a way to help left-behind home buyers get a foot on the property
            ladder. And while we&apos;re at it, we&apos;ve taken the hassle out of the buying
            process. In other words, we&apos;re here to make homeownership a reality again.
          </p>

          <Link href={routes.howitworks}>
            <a className="inline-block w-full px-4 py-3 mx-auto mt-8 mb-4 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow md:mb-0 md:w-auto bg-landing-orange hover:scale-105">
              See how it works
            </a>
          </Link>
        </div>

        <div className="h-60 mt-5 w-full md:w-2/5 md:flex-grow xl:flex-grow-0 md:h-48 md:top-16 xl:top-14 md:self-end md:ml-auto xl:ml-10 relative xl:w-[35.25rem] xl:h-[23.75rem]">
          <Image src="/about/building.svg" alt="building" objectFit="contain" layout="fill" />
        </div>
      </section>
    </SubLayout>
  );
};

export default TheOdds;
